import Box from "@material-ui/core/esm/Box";
import Radio from "@material-ui/core/esm/Radio";
import RadioGroup from "@material-ui/core/esm/RadioGroup";
import FormControlLabel from "@material-ui/core/esm/FormControlLabel";
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BoldSubtitle } from 'components/Text';
import useTransferTag from 'hooks/tags/useTransferTag';
var MoveObeDepositTypeEnum;
(function (MoveObeDepositTypeEnum) {
  MoveObeDepositTypeEnum["TransferDeposit"] = "Transfer deposit";
  MoveObeDepositTypeEnum["RecreateDeposit"] = "Recreate deposit";
})(MoveObeDepositTypeEnum || (MoveObeDepositTypeEnum = {}));
export default function ChooseDeposit() {
  const {
    t
  } = useTranslation();
  const {
    shouldTransferDeposit,
    setShouldTransferDeposit
  } = useTransferTag();
  const [depositHandlingType, setDepositHandlingType] = useState(MoveObeDepositTypeEnum.RecreateDeposit);
  const handleRadioGroupChange = event => {
    const {
      value
    } = event.target;
    setShouldTransferDeposit(value === MoveObeDepositTypeEnum.TransferDeposit);
    setDepositHandlingType(value);
  };
  useEffect(() => {
    setDepositHandlingType(shouldTransferDeposit ? MoveObeDepositTypeEnum.TransferDeposit : MoveObeDepositTypeEnum.RecreateDeposit);
  }, [shouldTransferDeposit]);
  return /*#__PURE__*/React.createElement(Box, {
    my: 2
  }, /*#__PURE__*/React.createElement(BoldSubtitle, null, t('transfer_tag.deposit_handling.title')), /*#__PURE__*/React.createElement(RadioGroup, {
    "aria-label": "select agreement option",
    name: "AgreementOption",
    value: depositHandlingType,
    onChange: handleRadioGroupChange
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: MoveObeDepositTypeEnum.TransferDeposit,
    control: /*#__PURE__*/React.createElement(Radio, null),
    label: t('transfer_tag.deposit_handling.transfer_deposit')
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    value: MoveObeDepositTypeEnum.RecreateDeposit,
    control: /*#__PURE__*/React.createElement(Radio, null),
    label: t('transfer_tag.deposit_handling.payout_create')
  })));
}